import { compose } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import withClientGeoLocation from 'components/common/hoc/withClientGeoLocation'
import { getCartDetail } from '../actions'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import BOTYourStore from './BOTYourStore'
import { getMapConfig } from './selectors'

const mapStateToProps = ({ myStore }, { coords }) => ({
  hasStore: Boolean(myStore),
  myStore: myStore || {},
  ...getMapConfig(myStore, coords)
})

export default compose(
  withType({ type: 'BOTYourStore' }),
  withClientGeoLocation,
  connect(mapStateToProps, { getCartDetail, showStoreLocatorModalInAppointmentMode })
)(BOTYourStore)
